import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import usersReducer from './usersSlice'
import productsReducer from './productsSlice'
import categoriesReducer from './categoriesSlice'
import schemeReducer from './schemeSlice'
import incentiveReducer from './incentiveSlice'
import distributorChannelReducer from './distributorChannelSlice'

import appReducer from './appSlice'

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    users: usersReducer,
    products: productsReducer,
    categories: categoriesReducer,
    scheme: schemeReducer,
    incentive: incentiveReducer,
    channels: distributorChannelReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {auth: AuthState, users: UsersState, scheme: SchemeState}
export type AppDispatch = typeof store.dispatch
